import { EventPrefix, Trigger } from '@pathccm/common-analytics/events'

import launchDarklyJsClient from './reporting/launchdarkly-js-client'
import { segment } from './reporting/segment'

// Check if a user is opening the link in a new tab
function userNewTab (event: Event): boolean {
  const typedEvent = event as Event & {
    ctrlKey: boolean
    shiftKey: boolean
    metaKey: boolean
    button: number
  }
  if (
    typedEvent.ctrlKey ||
    typedEvent.shiftKey ||
    typedEvent.metaKey ||
    (typeof typedEvent.button === 'number' && typedEvent.button === 1)
  ) {
    return true
  }
  return false
}

// Check if the link opens in new tab
function linkNewTab (element: HTMLAnchorElement, href: string | null): boolean {
  if (element.target === '_blank' && href != null && href !== '') {
    return true
  }
  return false
}

export const initializeAnalytics = (): void => {
  launchDarklyJsClient.on('ready', () => {
    // Capture Link Clicks
    window.addEventListener('click', (event: Event) => {
      let t

      if (event.target instanceof HTMLAnchorElement) {
        t = event.target
      } else if ((event.target as HTMLElement)?.parentElement instanceof HTMLAnchorElement) {
        if (event.target === null) return

        // Some instances we wrap buttons in a tags
        t = (event.target as HTMLElement).parentElement
      } else {
        return
      }

      const payload = {
        href: t.href,
        text: t.text,
        id: t.id,
        hash: t.hash,
        hostname: t.hostname,
        className: t.className
      }

      if (t.hostname !== window.location.hostname && !linkNewTab(t, t.href) && !userNewTab(event)) {
        // Workaround for Segment's trackLink method
        // https://github.com/segmentio/analytics-next/issues/1294
        event.preventDefault()
        // This timeout mimics the Segment behavior described in:
        // https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/#track-link
        setTimeout(() => {
          window.location.href = t.href
        }, 300)

        segment.track({
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.OUTBOUND_LINK_CLICKED
          },
          properties: {
            ...payload,
            trigger: Trigger.OUTBOUND_LINK_CLICKED
          }
        })
      } else if (t.hash !== undefined && t.hash !== '') {
        segment.track({
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.ANCHOR_LINK_CLICKED
          },
          properties: {
            ...payload,
            trigger: Trigger.ANCHOR_LINK_CLICKED
          }
        })
      } else {
        segment.track({
          eventName: {
            prefix: EventPrefix.MARKETING_SITE,
            trigger: Trigger.INTERNAL_LINK_CLICKED
          },
          properties: {
            ...payload,
            trigger: Trigger.INTERNAL_LINK_CLICKED
          }
        })
      }
    })
  })
}
